import React, { FC } from "react";
import Badge from "components/Badge/Badge";
import { BookItem } from "type";

export interface CategoryBadgeListProps {
  className?: string;
  itemClass?: string;
  categories: BookItem["category"];
}

const CategoryBadgeList: FC<CategoryBadgeListProps> = ({
  className = "flex flex-wrap space-x-2",
  itemClass,
  categories,
}) => {
  return (
    <div
      className={`nc-CategoryBadgeList ${className}`}
      data-nc-id="CategoryBadgeList"
    >
      {categories?.map((item, index) => (
        <Badge
          className={itemClass}
          key={index}
          name={item.name}
          href={item.url}
        />
      ))}
    </div>
  );
};

export default CategoryBadgeList;
